<template>
	<div>
		<div class="flex flex-wrap items-center gap-2">
			<div>
				<form class="flex items-center" @submit="addKeyword">
					<input type="text" class="input input-sm w-full pr-10" :placeholder="$t('Search term')" :class="fieldClasses" />
					<button type="submit" class="py-1 -ml-9 pl-2 pr-1 border-l">
						<MagnifyingGlassIcon class="w-4 h-4" />
					</button>
				</form>
			</div>
		</div>

		<div class="flex gap-2 items-start">

			<div class="grow flex flex-wrap gap-x-1">
				<button v-if="!filterIsEmpty" type="button" class="btn btn-xs btn-ghost mt-2" @click="resetFilter">
					{{ $t('Reset') }}
				</button>

				<Tag v-for="filterVal in filter?.getParamValues('keywords')" :key="filterVal.id" :removeable="true" class="tag-keyword tag-with-icon tag-xs mt-2" @remove="removeFilterValue('keywords', filterVal)">
					{{ filterVal.label }}
				</Tag>
			</div>
		</div>
	</div>
</template>

<script lang="ts">
import { mapStores } from "pinia";
import { useActivitiesStore } from "@/stores/Activities.store";
import { FilterParamValue } from "@/stores/filters/FilterParamValue";
import { ActivityFilterDef } from "@/stores/filters/ActivityFilterDef";
import { PropType } from "vue";

import { MagnifyingGlassIcon } from "@heroicons/vue/24/outline";
import Tag from "@/components/ui/Tag.vue";

export default {
	// This component is responsible for displaying and managing the filter options for the lesson plan list.
	// It does not manage the actual filtering of the lesson plans itself, but rather emits events to notify
	// the parent component of changes in the filter options.
	name: "ActivitiesFilter",

	emits: ["change", "reset"],

	props: {
		filter: {
			type: Object as PropType<ActivityFilterDef>,
		},
		fieldClasses: {
			type: String,
			default: "",
		},
	},

	components: {
		Tag,
		MagnifyingGlassIcon,
	},

	computed: {
		...mapStores(useActivitiesStore),

		filterIsEmpty() {
			if (!this.filter) return true;
			return this.filter.isEmpty();
		},
	},

	methods: {

		resetFilter() {
			// notify parent
			this.$emit("reset");
		},

		async addKeyword(event: any) {
			event.preventDefault();

			const keyword = event.target[0].value.trim();
			if (!keyword || keyword.length < 3) {
				return;
			}
			event.target[0].value = '';
			await this.addFilterValue("keywords", new FilterParamValue(keyword, keyword));
		},

		async addFilterValue(paramName: string, paramValue: FilterParamValue) {
			if (!this.filter) return;

			// update the filter instance
			this.filter.addParamValue(paramName, paramValue);

			// notify parent
			this.$emit("change", this.filter);
		},

		async removeFilterValue(paramName: string, paramValue: FilterParamValue) {
			if (!this.filter) return;

			this.filter.removeParamValue(paramName, paramValue);

			// notify parent
			this.$emit("change", this.filter);
		},

	},
};
</script>
